<script setup lang="ts">
//TODO: https://github.com/LeSuisse/vue-dompurify-html/issues/1917

const props = defineProps<{
  html: string
}>()
</script>

<template>
  <div v-html="html"></div>
</template>
